export const PRE_SALE_DROPDOWN = "PRE_SALE_DROPDOWN";
export const CREATE_PRE_SALE_SUPPLY = "CREATE_PRE_SALE_SUPPLY";
export const GET_BLOCKED_DATA='GET_BLOCKED_DATA';
export const UPDATE_BLOCKED_USER='UPDATE_BLOCKED_USER';